import React from 'react';
import { OK_200 } from 'common/config/api';
import { CAP_IQ_HEALTH_CHECK_TITLE, CAP_IQ_HEALTH_CHECK_URL, SERVICE_DOWN } from 'common/constants/valuations';
import { StatusCard } from 'components/StatusCard';
import useCapIQServiceHealthCheck from './hooks/useCapIQServiceHealthCheck';

const OK_STATUS_CHECK = 'working';
const CapIQStatusCard = () => {
  const { healthCheckValue, isLoading } = useCapIQServiceHealthCheck(CAP_IQ_HEALTH_CHECK_URL, OK_STATUS_CHECK);

  if (healthCheckValue !== SERVICE_DOWN) {
    return null;
  }

  return (
    <StatusCard
      isLoading={isLoading}
      title={CAP_IQ_HEALTH_CHECK_TITLE}
      value={healthCheckValue}
    />
  );
};

export default CapIQStatusCard;
